<template>
  <div class="global-labels">
    <el-form v-if="device === 'desktop'" inline class="form" @submit.native.prevent>
      <el-form-item
        v-for="(item, key) in labels"
        v-show="item.id ? item.viewable && !item.hidden : ((hasSide ? key <= 3 : key <= 4) ? true : showStatus)"
        :key="key"
        :label="item.title"
        :label-width="`80px`"
        :style="`width:calc(${device === 'desktop' ? (hasSide || fewLabelStatus ? '(100% - 32px * 2)/3' : '(100% - 32px * 3)/4') : '100% - 32px'}+50px);display:flex;`
          "
        :class="{
          'mr-0':
            (key && hasSide) || fewLabelStatus
              ? (key + 1) % 4 == 0
              : (key + 1) % 5 == 0
        }"
        :prop="item.itemBind"
      >
        <el-input
          v-if="item.type === 'input'"
          v-model="formDataObj[item.name]"
          :placeholder="item.placeholder ? item.placeholder : '请输入'"
          :disabled="item.id ? !item.editable : false"
          @change="handleInput"
          clearable
        />

        <el-select
          v-if="item.type === 'select'"
          v-model="formDataObj[item.name]"
          :placeholder="item.placeholder"
          :disabled="item.id ? !item.editable : false"
          :filterable="item.filterable"
          @change="handleInput"
        >
          <el-option
            v-for="(cItem, index) in item.selectData"
            :key="index"
            :label="cItem.name ? cItem.name : cItem.label"
            :value="cItem.id ? cItem.id : cItem.value"
          >
           <!-- <span>{{ cItem.name }}</span> -->
        </el-option>
        </el-select>
        <el-date-picker
          v-if="item.type === 'date'"
          v-model="formDataObj[item.name]"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :disabled="item.id ? !item.editable : false"
          @change="handleInput"
        />
        <el-date-picker
          v-if="item.type === 'datetime'"
          v-model="formDataObj[item.name]"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
          default-time="12:00:00"
          :disabled="item.id ? !item.editable : false"
          @change="handleInput"
        />
         <!-- 时间段选择器 -->
        <el-date-picker
          v-model="formDataObj[item.name]"
          v-if="item.type === 'date2'"
          type="daterange"
          range-separator="至"
          style="width:280px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <treeselect
                  class="searchTree"
                   v-if="item.type === 'tree'"
                   v-model="formDataObj[item.name]"
                  @change="changeTree" :multiple="false" :placeholder="item.placeholder"  :options="item.selectData" :normalizer="item.customNormalizer ? item.customNormalizer : customNormalizer"
                ></treeselect >
      </el-form-item>
      <el-form-item>
        <div style="height: 100%;margin-left: 15px;">
          <el-button
            type="primary"
            size="mini"
            v-if="showAdd"
            :loading="searching"
            @click="handleSave"
          >保存
          </el-button>
           <el-button
          type="primary"
          v-if="!showAdd"
          size="mini"
          icon="el-icon-search"
          :loading="searching"
          @click="handleSearch"
        >查询
        </el-button>
        <el-button
          size="mini"
          v-if="!showAdd"
          icon="el-icon-refresh-left"
          class="text-w"
          @click="handleReset"
        >重置
        </el-button>
        <el-button
          v-if="labels.length > 4"
          class="text-w"
          size="mini"
          @click="handleChangeShowSearch"
        >
          {{ showStatus ? '收起' : '展开' }}
          <i v-if="showStatus" class="el-icon-arrow-up" />
          <i v-else class="el-icon-arrow-down" />
        </el-button>
        </div>


      </el-form-item>
    </el-form>
    <el-button
      v-else-if="!hasSide"
      type="primary"
      class="mod-mobile"
      size="mini"
      icon="el-icon-search"
      :loading="searching"
      @click="showForm = true"
    >查询
    </el-button>
    <div v-if="device !== 'desktop'">
      <el-dialog
        title="查询"
        :visible.sync="showForm"
        width="100%"
        :before-close="() => { showForm = false }"
        class="showForm"
        top="5vh"
        :modal-append-to-body="false"
      >
        <el-form @submit.native.prevent>
          <el-form-item
            v-for="(item, key) in labels"
            :key="key"
            :label="item.title"
            :label-width="'80px'"
            :prop="item.itemBind"
          >
            <el-input
              v-if="item.type === 'input'"
              v-model="formDataObj[item.name]"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              :disabled="item.id ? !item.editable : false"
              @keyup.enter.native="handleSearch"
              @change="handleInput"
              clearable
            />
            <el-select
              v-if="item.type === 'select'"
              v-model="formDataObj[item.name]"

              :disabled="item.id ? !item.editable : false"
              @change="handleInput"
            >
              <el-option
                v-for="(cItem, index) in item.selectData"
                :key="index"
                :label="cItem.label"
                :value="cItem.value"
              />
            </el-select>
            <el-date-picker
              v-if="item.type === 'date'"
              v-model="formDataObj[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :disabled="item.id ? !item.editable : false"
              @change="handleInput"
            />
            <el-date-picker
              v-if="item.type === 'datetime'"
              v-model="formDataObj[item.name]"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
              :disabled="item.id ? !item.editable : false"
              @change="handleInput"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">

          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            :loading="searching"
            @click="handleSearch"
          >查询
          </el-button>
          <el-button
            size="mini"
            icon="el-icon-refresh-left"
            class="text-w"
            @click="handleReset"
          >重置
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  name: 'GlobalLabels',
  components: {
    Treeselect
  },
  props: {
    formDataObj: {
      type: Object,
      default: function() {
        return {
        }
      }
    },
    showAdd: {
      type: Boolean,
      default: false
    },
    resetAll: {
      type: Boolean,
      default: false
    },
    isHidden: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'title'
    },
    // 决定显示3行还是4行
    hasSide: {
      type: Boolean,
      default: true
    },
    labels: {
      // 条件搜索的数据 type: input || select || date
      type: Array,
      default: function() {
        return []
      }
    },
    fewLabelStatus: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: 'desktop'
    },
  },
  computed: {

  },
  data () {
    return {
      showForm: false,
      showStatus: false,
      searching: false,

      rules: {},
      data: [],
      selectTree: [],
      isShowSelect: false,
      value1: '',
    }
  },
  watch: {
    resetAll (n) {
      if (n) {
        this.formDataObj = {

        }
      }
    },
    labels: {
      handler: function() {
        if (!this.labels.length) return
        this.labels.forEach(item => {
          if (item.default) this.formDataObj[item.name] = item.default
        })
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {

    // console.log(this.data)
    setTimeout(() => {
      const contentEl = this.$parent.$refs.content
      this.$nextTick(() => {
        if (contentEl && contentEl.offsetHeight) this.$emit('calc', contentEl.offsetHeight)
      })
    }, 1000)
    window.addEventListener('resize', () => {
      this.calcHeight()
    })
  },
  created () {

  },
  methods: {
    customNormalizer (node) {
      return {
        id: node.id,
        label: node.name,
        children: node.child
      };
    },
    setTreeMenu (data, node, n) { // 获取子组件值
      console.log(data)
    },
    handleSave () {
      this.$emit('handleSave', this.formDataObj)
    },
    selectClick () {
      if (this.selectTree == []) {
        selectTree(sessionStorage.getItem('appAcctId')).then((tree) => {
          this.selectTree = tree.data
        })
      }
      // console.log(this.$refs.select2)
      if (!this.isShowSelect) {
        this.$refs.select2[0].blur()
        this.isShowSelect = true
      } else {
        this.$refs.select2[0].blur()
        this.isShowSelect = false
      }
    },
    closeTree (e) {
      // console.log(e)
      // // this.isShowSelect = false
      // console.log(e.target)
    },
    // 收起展开
    handleChangeShowSearch () {
      this.showStatus = !this.showStatus
      this.calcHeight()
    },
    // 条件搜索
    handleSearch () {
      for (var i = 0; i < this.labels.length; i++) {
        if (!this.formDataObj[this.labels[i].name] && this.labels[i].required && !this.labels[i].hidden) {
          var mess = this.labels[i].title + '不能为空'
          this.$message.info(mess)
          return false
        }
      }
      this.showForm = false
      this.searching = true
      // console.log(this.formDataObj)
      this.$emit('search', this.formDataObj)
      setTimeout(() => {
        this.searching = false
      }, 100)
    },
    // 条件重置
    handleReset () {
      this.formDataObj = {}
      this.$emit('reset', this.formDataObj)
    },
    // 输入框输入触发事件
    handleInput () {
      console.log(this.formDataObj)
      this.$emit('input', this.formDataObj)
    },
    calcHeight () {
      const contentEl = this.$parent.$refs.content
      if (!contentEl) return
      this.$nextTick(() => {
        if (contentEl && contentEl.offsetHeight) this.$emit('calc', contentEl.offsetHeight)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
  margin: 0;
  padding: 2em 10vw 0;
}

.mod-tree-mobile {
  position: absolute;
  right: 16px;
  top: 24px;
}

.mod-mobile {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translate(0, -50%);
}

.global-labels {
  padding: 8px;
  margin: 8px 0;
  padding-bottom: 0;
}

.form {
  display: flex;
  flex-wrap: wrap;
}

.mr-0 {
  margin-right: 0 !important;
}

.text-w.el-button {
  color: #323233;
}

.el-button--small {
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 2px;
}

.delete.el-button {
  border-color: #efefef;
}

.el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  border-radius: 0.125rem !important;
}



.search.el-button {
  width: 40px;
  height: 32px;
  padding: 10px;
  background-color: #d9d9d9;
  border-bottom-left-radius: 0;
}

.el-input-group {
  overflow: hidden;
}

.el-tag--medium {
  line-height: 14px;
  padding: 0px 3px;
  display: inline;
  border-radius: 2px;
}

.grey-tab {
  padding: 10px;
  background: #f7f8fa;
  margin-bottom: 10px;
}

.flex-1 {
  display: flex;
  justify-content: center;


}

.el-button {
  margin-right: 4px !important;
}

.el-form-item__content,
.el-select {
  flex: 1;
}

.el-form-item__label {
  color: #333333;
  width: 80px;
}

.el-select.el-select--medium,
.el-input {
  width: 100%;
}

.el-form--inline .el-form-item {
  margin-right: 32px;
  margin-bottom: 8px;
}

.el-button:not(.search) {
  margin-left: 0;
  margin-right: 8px;
}

.el-button:not(.search):last-child {
  margin-right: 0;
}

.el-range-separator {
  width: 20px;
}

.vue-treeselect {
  height: 32px !important;
  line-height: 32px !important;
}

::v-deep .vue-treeselect__control {
  height: 32px !important;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/searchForm/index.vue